import { PoComboOption, PoTableColumn } from "@po-ui/ng-components";
import { FiltroLista, IFiltroLista } from "src/app/filter/filtro-lista";


export interface IFiltroDadosNetrinAtualizacao extends IFiltroLista {
  ACOLUNAS: Array<PoTableColumn>;
  DULTCOM: Date | undefined;
  DATU: Date | undefined;
  CFORNECEDORLOJA: string;
  CCLIENTELOJA: string;
  CTIPO:  'C' | 'F' | ' ';
  CSTATUS:  'A' | 'E' | 'F' | ' ';
}

export class FiltroDadosNetrinAtualizacao extends FiltroLista {
  dados: IFiltroDadosNetrinAtualizacao = this.setDefault();
  timeout = this.getDataString(30);


  public readonly tipoOrigemPoComboOptions: Array<PoComboOption> = [
    { label: 'Todos'     , value: ' ' },
    { label: 'Cliente'   , value: 'C' },
    { label: 'Fornecedor', value: 'F' },
  ]

  public readonly statusProcessoPoComboOptions: Array<PoComboOption> = [
    { label: 'Todos'             , value: ' ' },
    { label: 'Aguardando Análise', value: 'A' },
    { label: 'Erro'              , value: 'E' },
    { label: 'Análise Finalizada', value: 'F' },
  ]

  public setDefault(): IFiltroDadosNetrinAtualizacao {
    return {
      page: 1,
      pageSize: 20,
      filter: '',
      order: '',
      CFORNECEDORLOJA: '',
      CCLIENTELOJA: '',
      DULTCOM: this.getData(-365),
      DATU: undefined ,
      CTIPO: ' ',
      CSTATUS: ' ',
      ACOLUNAS: []
    };
  }

  atualizarColumnsManager(colunas: Array<PoTableColumn>): Array<PoTableColumn> {
    if(this.dados.ACOLUNAS.length) {
      colunas = colunas.map((i)=> ({...i, visible: this.dados.ACOLUNAS.find((a)=> a.property === i.property)?.visible, fixed: this.dados.ACOLUNAS.find((a)=> a.property === i.property)?.fixed}));
    }

    return colunas;
  }
}
